import classNames from "classnames";

import {Table} from "@/components/table/Table.tsx";
import {ColumnSpec} from "@/components/table/Table.types.ts";
import {ReportDisplayTable, ReportRow, ReportRowField, ReportTableVariant} from "@/pages/analyzer/Analyzer.types.ts";
import {getReportTag} from "@/pages/analyzer/Analyzer.utils.ts";
import {AnalyzerReportTag} from "@/pages/analyzer/components/AnalyzerReportTag.tsx";

import styles from "./AnalyzerReportTable.module.scss";

export const AnalyzerReportTable = ({
  title,
  variant = ReportTableVariant.DEFAULT,
  columns,
  rows,
  rationale,
  note,
}: ReportDisplayTable) => {
  const specs: ColumnSpec<ReportRow>[] = columns.map(({field, title: fieldTitle}) => ({
    fieldName: field,
    fieldTitle,
    ...(field === ReportRowField.LABEL && {
      accessor: (row: ReportRow) => {
        const tag = getReportTag(row);
        return (
          <span className={row.emphasis && styles[row.emphasis]}>
            {row.label}
            {tag && <AnalyzerReportTag tag={tag} className={styles.chip} />}
          </span>
        );
      },
    }),
  }));

  const isSummary = variant === ReportTableVariant.SUMMARY;

  return (
    <div className={styles.table}>
      {title && (
        <div className={styles.title} role="heading" aria-level={4}>
          {title}
        </div>
      )}
      <div className={classNames({[styles.compact]: isSummary})}>
        <Table<ReportRow>
          rows={rows}
          specs={specs}
          fixedWidth
          minWidth={isSummary ? "16rem" : "40rem"}
          className={styles[variant]}
        />
      </div>
      {rationale && (
        <div className={styles.rationale}>
          <span className={styles.rationaleLabel}>Why this matters:</span> {rationale}
        </div>
      )}
      {note && <div className={styles.rationale}>{note}</div>}
    </div>
  );
};
